export const COOKIE_NAMES = {
	XLTOVL_COOKIE: 'xlToVl',
	TV_GEMIST_COUNTER: 'tvGemistCounter',
};

export const TV_GEMIST_COUNTER_LIMIT = 1;
